import React, { useState, useRef, useEffect } from 'react';
import { usePopper } from 'react-popper';

interface DropdownProps {
    children: React.ReactNode;
    dropdownRender: React.ReactNode;
    trigger?: ('click' | 'hover')[];
}

const Dropdown: React.FC<DropdownProps> = ({
    children,
    dropdownRender,
    trigger = ['click']
}) => {
    const [open, setOpen] = useState(false);
    const [referenceElement, setReferenceElement] = useState<HTMLDivElement | null>(null);
    const [popperElement, setPopperElement] = useState<HTMLDivElement | null>(null);
    const timeoutRef = useRef<NodeJS.Timeout | undefined>(undefined);

    const { styles, attributes } = usePopper(referenceElement, popperElement, {
        placement: 'bottom-start',
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [0, 8],
                },
            },
        ],
    });

    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    const handleMouseEnter = () => {
        if (trigger.includes('hover')) {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
            setOpen(true);
        }
    };

    const handleMouseLeave = () => {
        if (trigger.includes('hover')) {
            timeoutRef.current = setTimeout(() => {
                setOpen(false);
            }, 200);
        }
    };

    const handleClick = (e: React.MouseEvent) => {
        console.log('jamdeC;oas');
        if (trigger.includes('click')) {
            e.stopPropagation();
            setOpen(!open);
        }
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                open &&
                popperElement &&
                referenceElement &&
                !popperElement.contains(event.target as Node) &&
                !referenceElement.contains(event.target as Node)
            ) {
                setOpen(false);
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, [open, popperElement, referenceElement]);

    return (
        <>
            <div
                ref={setReferenceElement}
                onClick={handleClick}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                style={{ cursor: 'pointer' }}
            >
                {children}
            </div>
            {open && (
                <div
                    ref={setPopperElement}
                    style={{
                        ...styles.popper,
                        zIndex: 1000,
                        background: 'white',
                        borderRadius: '4px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                        padding: '12px'
                    }}
                    {...attributes.popper}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                >
                    {dropdownRender}
                </div>
            )}
        </>
    );
};

export default Dropdown;